import * as React from 'react';
import { useSelector } from 'react-redux';

import { getIsBrokerBannerAvailable } from '../../selectors/broker';
import { getNewbuildingBlackFridayActive } from '../../selectors/newbuildingBlackFriday';

import { NewbuildingConsultBannerContainer } from '../NewbuildingConsultBanner';
import { BrokerBannerContainer } from './BrokerBannerContainer';
import { NewbuildingBlackFridayBannerContainer } from '../NewbuildingBlackFridayBanner';

export function BannerContainer() {
  const isBrokerBannerAvailable = useSelector(getIsBrokerBannerAvailable);
  const isNewbuildingBlackFridayActive = useSelector(getNewbuildingBlackFridayActive);

  if (isBrokerBannerAvailable) {
    return <BrokerBannerContainer />;
  }

  // TODO: Удалить в задаче CD-183468.
  if (isNewbuildingBlackFridayActive) {
    return <NewbuildingBlackFridayBannerContainer />;
  }

  return <NewbuildingConsultBannerContainer />;
}
